import React from 'react'
import { Button } from '@chakra-ui/react'

export const PurchaseButton = ({ onClick, isLoading = false, ...props }) => (
  <Button
    w="100%"
    h="40px"
    bgColor="primary.main"
    color="white"
    fontSize="sm"
    fontWeight="600"
    onClick={onClick}
    loading={isLoading}
    _hover={{ opacity: 0.8 }}
    {...props}
  >
    購入する
  </Button>
)
